// src/components/ModalComponent.js
import { Box, Modal, Typography } from "@mui/material";
import React from "react";
import "../styles/ModalComponent.css"; // Import the CSS file for custom styles

const ModalComponent = ({ open, handleClose }) => {
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <Box
        sx={{
          position: 'absolute',
          textAlign: 'center',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 420,
          bgcolor: 'var(--modal-background-color)',
          color: 'var(--modal-text-color)',
          borderColor: 'var(--text-color)',
          boxShadow: 24,
          p: 4,
          '@media (max-width: 420px)': {
            width: '80%',
          },
        }}
      >
        <Typography variant="h6" className="header-title">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="96"
            height="90"
            fill="none"
            viewBox="0 0 96 60"
          >
            <path
              fill='var(--modal-text-color)'
              fillRule="evenodd"
              d="M5.133 10.155C5.133 9.517 5.651 9 6.29 9h10.44c.639 0 1.156.517 1.156 1.155v9.701c0 .638-.517 1.155-1.155 1.155H6.289a1.155 1.155 0 0 1-1.156-1.155v-9.7Zm.6 12.548c-.957 0-1.733.776-1.733 1.733v19.222c0 .957.776 1.733 1.733 1.733h11.553c.957 0 1.732-.776 1.732-1.733V24.436c0-.957-.775-1.733-1.732-1.733H5.733Zm.556 1.068c-.638 0-1.156.517-1.156 1.155v9.7c0 .639.518 1.156 1.156 1.156h10.44c.639 0 1.156-.517 1.156-1.155v-9.701c0-.638-.517-1.155-1.155-1.155H6.289ZM22.115 9h13.308c4.498 0 8.195 1.124 11.09 3.373 2.928 2.219 4.39 5.33 4.39 9.335v10.929c0 2.136-.368 4.009-1.105 5.617 1.347.169 2.44.781 3.278 1.837v-.86a.72.72 0 0 1 .222-.527.72.72 0 0 1 .526-.222h4.852a.72.72 0 0 1 .527.222.72.72 0 0 1 .222.527l.028 13.198c0 2.218-.721 3.863-2.163 4.935C55.848 58.454 53.954 59 51.606 59c-1.46 0-2.763-.203-3.91-.61-1.145-.388-2.005-.869-2.578-1.442-1.164-1.146-1.747-2.116-1.747-2.911a.72.72 0 0 1 .222-.527.72.72 0 0 1 .527-.222h5.407c.332 0 .6.204.804.61.222.425.6.638 1.137.638.794 0 1.192-.499 1.192-1.497V51.07c-.906.795-2.19 1.193-3.854 1.193-1.645 0-3.013-.5-4.104-1.498-1.072-.998-1.608-2.588-1.608-4.769v-1.414c0-.156.003-.31.01-.461-2.194.847-4.739 1.27-7.635 1.27H22.115a1.2 1.2 0 0 1-.878-.37 1.2 1.2 0 0 1-.37-.878V10.248a1.2 1.2 0 0 1 .37-.878 1.2 1.2 0 0 1 .878-.37Zm10.305 9.011V36.38h3.003c1.048 0 1.88-.308 2.496-.924.647-.647.97-1.587.97-2.82V21.709c0-2.465-1.155-3.697-3.466-3.697H32.42Zm18.853 29.427c.87 0 1.331-.462 1.387-1.386v-1.498c-.056-.924-.518-1.386-1.386-1.386-.925 0-1.387.536-1.387 1.608v1.054c0 1.072.462 1.608 1.386 1.608Zm23.923-.11h-8.262v.138c0 1.127.36 1.691 1.08 1.691.204 0 .454-.148.75-.443.295-.296.619-.444.97-.444h5.24c.407 0 .61.203.61.61 0 .906-.684 1.848-2.052 2.828-1.349.98-3.188 1.47-5.517 1.47-2.31 0-4.205-.601-5.684-1.803-1.46-1.22-2.19-2.893-2.19-5.018v-1.331c0-2.015.748-3.65 2.245-4.908 1.498-1.275 3.457-1.913 5.878-1.913 2.44 0 4.326.712 5.657 2.135 1.349 1.423 2.024 3.226 2.024 5.407v.832a.72.72 0 0 1-.222.526.72.72 0 0 1-.527.222Zm-6.044-3.578c0-1.109-.37-1.663-1.11-1.663-.739 0-1.108.554-1.108 1.663v.111h2.218v-.11Zm23.807.75v7.652a.72.72 0 0 1-.222.526.72.72 0 0 1-.527.222h-5.295a.72.72 0 0 1-.527-.222.72.72 0 0 1-.222-.526v-7.459c0-1.017-.462-1.525-1.386-1.525-.925 0-1.387.508-1.387 1.525v7.459a.72.72 0 0 1-.222.526.72.72 0 0 1-.526.222h-5.268a.72.72 0 0 1-.527-.222.72.72 0 0 1-.222-.526v-12.92a.72.72 0 0 1 .222-.528.72.72 0 0 1 .527-.222h4.852a.72.72 0 0 1 .527.222.72.72 0 0 1 .221.527v.915c.481-.573 1.128-1.035 1.941-1.386a6.479 6.479 0 0 1 2.662-.555c1.516 0 2.791.536 3.826 1.608 1.035 1.054 1.553 2.616 1.553 4.686Z"
              clipRule="evenodd"
            />
            <text x="8" y="74" fontFamily="Arial" fontSize="14" fill='var(--modal-text-color)'>
              version 1.0.2
            </text>
          </svg>
        </Typography>
        <Box className="modal-content" p={2}>
          <Typography id="modal-title" variant="h6" component="h2">
            Welcome to iDgen
          </Typography>
          <Typography id="modal-text" className="modal-text">
            Click the menu button in the header to get started!
          </Typography>
          <Typography
            id="modal-description"
            className="modal-description"
            sx={{ mt: 2 }}
          >
            This <span>completely free</span> tool empowers you to design
            personalized ID cards that showcase your NFTs with style. Whether
            you're highlighting rare traits, emphasizing ownership, or simply
            expressing your unique taste, iDgen makes it effortless to show
            everyone who you really are in the ever-evolving digital art
            landscape.
          </Typography>
          <Typography id="modal-powered" className="modal-powered">
            ⚡powered by plushie gang⚡
          </Typography>
        </Box>
      </Box>
    </Modal>
  );
};

export default ModalComponent;